// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import UnloadingTasks from './UnloadingTasks';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(UnloadingTasks);
